import React, { useState, useEffect } from 'react';
import { T } from '../../../traks';
import { Row, Col, Button } from 'reactstrap';
import { PaymentSpinner } from './PaymentSpinner';
import PaymentConfigs from './PaymentConfigs'

export const PaymentFrame = ({
  companyId = PaymentConfigs.prod.companyId,
  apiKey = PaymentConfigs.prod.apiKey,
  orderId,
  test = PaymentConfigs.prod.test,
  paymentType = 'creditcard_iframe',
  onLoading = () => {},
  onError = () => {},
  onComplete = () => {},
  onPaymentTypes = () => {},
  redirectURL = '',
  setView,
}) => {
  const [iframeUrl, setIFrameUrl] = useState();
  const [html, setHtml] = useState();
  const [open, setOpen] = useState(false);
  const [socket, setSocket] = useState();

  const handleGoBack = () => {
    setView('checkout');
  };

  const cleanOrderId = orderId.replace(/"/g, '');

  const getWebSocketURL = (companyId, apiKey, test) => {
    let auth = btoa(apiKey);
    let base = test ? 'checkout-test' : 'checkout';
    return `wss://${base}.amopus.com/?authorization=${auth}&companyId=${companyId}`;
  };

useEffect(() => {
  let isMounted = true;
  const s = new WebSocket(getWebSocketURL(companyId, apiKey, test));

  s.addEventListener('open', () => {
    console.log('socket open.');
    if (isMounted) setOpen(true);
  });

  s.addEventListener('close', () => {
    console.log('socket closed.');
    if (isMounted) {
      onLoading(false);
      setSocket(null);
    }
  });

  s.onmessage = (m) => {
    if (!isMounted) return;
    
    let result = JSON.parse(m.data);
    let data = result.data;
    
    if (result.status === 'ok') {
      if (data.iframe) setIFrameUrl(data.iframe);
      if (data.html) setHtml(data.html);
      if (data.availableCheckoutTypes) onPaymentTypes(data.availableCheckoutTypes);
    } else if (result.status === 'error') {
      onError(data.message);
    } else if (result.status === 'success') {
      onComplete(result);
    } else {
      onError(data.message || 'Unknown error');
    }
    onLoading(false);
  };

  setSocket(s);
  
  return () => {
    isMounted = false;
    s.close();
  };
}, []);

  useEffect(() => {
    if (socket && open) {
      let msg = {
        action: 'sendmessage',
        checkoutType: paymentType,
        orderId: cleanOrderId,
        redirectURL,
      };
      onLoading(true);
      socket.send(JSON.stringify(msg));
    }
  }, [open, cleanOrderId, paymentType, socket]);

  useEffect(() => {
    if (html) {
      let re = /<script[\s\S]*?>(?<scripts>[\s\S]*?)<\/script>/g;
      let match = re.exec(html);
      if (match && match.groups && match.groups.scripts) {
        try {
          Function(match.groups.scripts)();
        } catch (err) {
          console.error("Error executing script:", err);
        }
      }
    }
  }, [html]);

  return (
    <div className="container payment-container">
      {(!iframeUrl && !html) ? (
        <div className="text-center my-4 payment-spinner-container">
          <PaymentSpinner />
        </div>
      ) : (
        <React.Fragment>
          {iframeUrl && open && (
            <iframe
              title="checkout"
              src={iframeUrl}
              className="my-4"
              style={{ width: '100%', height: '80vh' }}
            />
          )}
          {html && open && (
            <div
              dangerouslySetInnerHTML={{
                __html: html.replace(
                  /<iframe\s/g,
                  '<iframe sandbox="allow-same-origin allow-scripts allow-popups allow-forms" '
                ),
              }}
            />
          )}
        </React.Fragment>
      )}
      <footer>
        <Row className="ml-0 p-2 w-100 order-details-footer">
          <Col className="text-left">
            <Button
              className="ad_new_game_button px-4 py-2"
              onClick={handleGoBack}
            >
              {'<'} <T>Back</T>
            </Button>
          </Col>
        </Row>
      </footer>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Payment/PaymentFrame.js